<script  setup>
import {reactive, ref, watch} from "vue";
import {ElButton, ElCol, ElLoading, ElMessage, ElRow} from "element-plus";
import axios from "axios";
const props = defineProps({
    destinations:Object,
    itineries:Object,
    form:Object
});
import moment from 'moment';
import {Delete} from "@element-plus/icons-vue";
import { moneyTotal, roundMoney } from '../../../utils/money';
const emit = defineEmits(['canceli','added']);

const destinations=props.destinations;
const itineries=props.itineries;
const eform=props.form;
const searchinp=ref('');
const model=ref(true);


const ruleFormRef = ref();

const editform=reactive(
    {
        "type":'',
        "vechile":'',
        "pointslist":['',''],
        "pricing":{
            "total":0,
            "adult":0 ,
            "child":0 ,
            "infant":0 ,
        }
    }
)

watch(
    () => editform.pricing,
    () => {
        updateupricecount();
    },
    { deep: true }
)

const updateupricecount = () => {
    editform.pricing.total = moneyTotal(eform.adults, editform.pricing.adult, eform.childs, editform.pricing.child, eform.infants, editform.pricing.infant);
};

const submitForm = async (formEl) => {

    if (!formEl) return
    await formEl.validate((valid, fields) => {

        if (valid) {

            addTranfer()

        }
    })
}

const addTranfer = () => {

    itineries.transfers.push({
        "id":"id"+moment().format('x'),
        "type":editform.type,
        "vechile":editform.vechile,
        "pointslist":editform.pointslist,
        "pricing":{
            "total":roundMoney(editform.pricing.total),
            "adult":roundMoney(editform.pricing.adult),
            "child":roundMoney(editform.pricing.child),
            "infant":roundMoney(editform.pricing.infant),
        },

    })


    ElMessage({
        message: 'Tranfer Added Sucessfully.',
        type: 'success',
    });


    emit("added")
};

const removepoint = (index) => {


    editform.pointslist.splice(index, 1)

}
const addpoint = () => {


    editform.pointslist.push("");


}

const transfertypes=ref(
    [
        "Shared",
        "Private"
    ]
)

const vechilestypes=ref(
    [
        "Sedan",
        "SUV",
        "Eeco",
    ]
)

</script>

<template>


    <el-drawer
        size="80%"
        v-model="model"
        :title="'Day - '+itineries.day+' Tranfer Add'"
        @closed="emit('canceli')"
    >
        <el-row>
            <el-col :span="24">
                <el-form
                    ref="ruleFormRef"
                    :model="editform"
                    status-icon
                    label-width="auto"
                    class="demo-ruleForm"
                    label-position="top"
                    size="small"

                >
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-row :gutter="10">
                                <el-col :span="12">

                                    <el-form-item
                                        class="mt-3"
                                        prop="type"
                                        :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }"
                                    >

                                        <el-select
                                            v-model="editform.type"
                                            placeholder="Choose Transfer Type"
                                            style="width: 100%"

                                        >
                                            <el-option
                                                v-for="item in transfertypes"
                                                :key="item"
                                                :label="item"
                                                :value="item"
                                            />
                                        </el-select>

                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">

                                    <el-form-item
                                        class="mt-3"
                                        prop="vechile"

                                    >

                                        <el-select
                                            filterable
                                            allow-create
                                            clearable
                                            v-model="editform.vechile"
                                            placeholder="Choose Vechile Type"
                                            style="width: 100%"

                                        >
                                            <el-option
                                                v-for="item in vechilestypes"
                                                :key="item"
                                                :label="item"
                                                :value="item"
                                            />
                                        </el-select>

                                    </el-form-item>
                                </el-col>

                                <el-col :span="24">
                                    <el-form-item
                                        v-for="(ttr,index2) in editform.pointslist"
                                        :prop="'pointslist['+index2+']'"
                                        :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }"
                                        :key="index2"
                                    >


                                        <el-input
                                            v-model="editform.pointslist[index2]"
                                            placeholder="Enter Destination"
                                        >
                                            <template #append><el-button v-if="editform.pointslist.length>2" type="danger" @click="removepoint(index2)"><Delete style="width: 1em; height: 1em; margin-right: 8px" /></el-button></template>
                                        </el-input>


                                    </el-form-item>
                                    <el-button @click="addpoint()" class="mb-2" size="small" >Add</el-button>

                                </el-col>
                            </el-row>
                        </el-col>
                        <el-col :span="12">
                            <el-row :gutter="20">
                                <el-col :span="8" >
                                    <el-form-item label="Adults" >
                                        <el-input v-model="eform.adults"  placeholder="Adults" readonly/>
                                    </el-form-item>

                                </el-col>
                                <el-col :span="8" >
                                    <el-form-item label="Adult Pricing" prop="pricing.adult" :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                        <el-input v-model="editform.pricing.adult"  placeholder="Adult Pricing" type="number" />
                                    </el-form-item>

                                </el-col>


                            </el-row>
                            <el-row :gutter="20" v-if="eform.childs>0">
                                <el-col :span="8" >
                                    <el-form-item label="Child" >
                                        <el-input v-model="eform.childs"  placeholder="Child" readonly/>
                                    </el-form-item>

                                </el-col>
                                <el-col :span="8" >
                                    <el-form-item label="Child Pricing" prop="pricing.child" :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                        <el-input v-model="editform.pricing.child"  placeholder="Child Pricing"  type="number" />
                                    </el-form-item>

                                </el-col>


                            </el-row>
                            <el-row :gutter="20" v-if="eform.infants>0">
                                <el-col :span="8" >
                                    <el-form-item label="Infants" >
                                        <el-input v-model="eform.infants"  placeholder="Infants" readonly/>
                                    </el-form-item>

                                </el-col>
                                <el-col :span="8" >
                                    <el-form-item label="Infants Pricing" prop="pricing.infant" :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                        <el-input v-model="editform.pricing.infant"  placeholder="Infants Pricing"  type="number"/>
                                    </el-form-item>

                                </el-col>


                            </el-row>
                            <el-row :gutter="20" >
                                <el-col :span="8" >


                                </el-col>
                                <el-col :span="8" >
                                    <el-form-item label="Total Pricing" prop="pricing.total" :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                                        <el-input v-model="editform.pricing.total"  placeholder="Total Pricing"  type="number" readonly/>
                                    </el-form-item>

                                </el-col>


                            </el-row>
                        </el-col>
                    </el-row>


                </el-form>
            </el-col>
        </el-row>

        <template #footer>
            <div class="dialog-footer">
                <el-button @click="emit('canceli')">Cancel</el-button>
                <el-button type="primary" @click="submitForm(ruleFormRef)">
                    Save
                </el-button>
            </div>
        </template>
    </el-drawer>
</template>

<style scoped>

</style>
